import React from 'react'
import { PATHS } from 'Config/Routing/paths'
import SubmitButton from '../../../Components/Form/SubmitButton'
import AuthWrapper from '../../../Containers/Auth/AuthWrapper'
import LinkButtonWithText from '../../Buttons/LinkButtonWithText'
import { getDeepLink } from '../../../shared/libraries/deepLinking'
import { CONFIG } from '../../../Config/config'
import PasswordResetConfirmIllustration from '../../../Assets/Images/icons/PasswordResetConfirmIllustration'
import { Box, Grid } from '@material-ui/core'
import { authorization } from '../../../Module/Auth/Auth'

const ResetPasswordSuccess = ({ classes, history }) => {
  const backToPlatform = () => {
    if (authorization.isLogged()) {
      history.push(PATHS.main.dashboard)
    } else {
      history.push(PATHS.main.login)
    }
  }

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
    navigator.userAgent,
  )

  return (
    <AuthWrapper>
      <Grid container spacing={4}>
        <Grid
          container
          item
          xs={12}
          md={6}
          alignItems="center"
          justifyContent="center"
          className="h-100"
        >
          <Grid
            container
            item
            xs={12}
            alignItems="center"
            justifyContent="center"
            className={'content has-large-padding h-100'}
          >
            <Box className="content-inner">
              <h1 className="text-center">Password reset successfully!</h1>
              {isMobile ? (
                <LinkButtonWithText
                  href={getDeepLink(
                    CONFIG.APPS_FLYER.DEEP_LINK_DOMAIN,
                    CONFIG.APPS_FLYER.DEEP_LINK_TEMPLATE_ID,
                    'changedPassword',
                  )}
                  label="Back to App"
                  title="Back to App"
                />
              ) : (
                <SubmitButton className={'buttonNext'} onClick={backToPlatform}>
                  <span>Return</span>
                </SubmitButton>
              )}
            </Box>
          </Grid>
        </Grid>
        <Grid
          container
          item
          xs={12}
          md={6}
          justifyContent="center"
          alignItems="center"
          direction="column"
        >
          <PasswordResetConfirmIllustration className={'illustration'} />
        </Grid>
      </Grid>
    </AuthWrapper>
  )
}

export default ResetPasswordSuccess
